.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(16, 13, 10, 0.94);
  z-index: 60;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: overlayIn 0.22s ease both;
}
.imageWrap {
  width: min(86vw, 392px);
  touch-action: pan-y pinch-zoom;
  user-select: none;
}
.image {
  /* 높이 제한에 걸려도 요소의 모서리가 실제 사진의 모서리와 일치해야 한다. */
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 68vh;
  max-height: 68svh;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  border-radius: 10px;
}
.bufferImage {
  position: fixed;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
.counter {
  margin-top: 16px;
  font-family: var(--font-label);
  font-size: 13px;
  letter-spacing: 3px;
  color: rgba(255, 255, 255, 0.85);
}
.prev,
.next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(16, 13, 10, 0.35);
  color: var(--cream);
  cursor: pointer;
  display: grid;
  place-items: center;
}
.prev {
  left: 10px;
}
.next {
  right: 10px;
}
.navIcon {
  width: 11px;
  height: 11px;
  box-sizing: border-box;
  border-top: 1.5px solid currentColor;
  border-right: 1.5px solid currentColor;
}
.navIconPrev {
  transform: rotate(-135deg);
}
.navIconNext {
  transform: rotate(45deg);
}
.close {
  position: absolute;
  top: 16px;
  /* 노치·다이내믹 아일랜드 아래로 숨지 않게. 지원하지 않는 엔진은 위 줄을 쓴다. */
  top: calc(16px + env(safe-area-inset-top, 0px));
  right: 16px;
  right: calc(16px + env(safe-area-inset-right, 0px));
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(16, 13, 10, 0.35);
  color: var(--cream);
  font-size: 17px;
  cursor: pointer;
  font-family: var(--font-label);
}
